import { render, staticRenderFns } from "./DingInfo.vue?vue&type=template&id=9d0b13b4&scoped=true&"
import script from "./DingInfo.vue?vue&type=script&lang=js&"
export * from "./DingInfo.vue?vue&type=script&lang=js&"
import style0 from "./DingInfo.vue?vue&type=style&index=0&id=9d0b13b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0b13b4",
  null
  
)

export default component.exports